//Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Extend
import baseFixedRentalService from '@/scripts/fixedRental/baseFixedRentalService';

// Constant
import { ROUTE_URL } from '@/constant/route';
import { SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { PERIOD, ELEMENT_LIST_PERIOD, FIXED_RENTAL_STATUS, ELEMENT_LIST_PERIOD_ON_CREATED } from "@/constant/fixedRental";

// Component 

export default {

  extends: baseFixedRentalService,

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    ELEMENT_LIST_PERIOD_LIST() {
        return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD;
    },
    listPeriod() {
        return process.env.VUE_APP_CODE === 'IRENDER_GPU_VN' ? ELEMENT_LIST_PERIOD_ON_CREATED(this.targetImage.packageId) : ELEMENT_LIST_PERIOD;
    }
  },

  data() {
    return {
      routeUrl: ROUTE_URL,
      //listPeriod: ELEMENT_LIST_PERIOD,
      fixedRentalStatus: FIXED_RENTAL_STATUS,

      request: {
        period: PERIOD.THREE_HOUR,
        periodUnit: 1,
      }
    };
  },

  props: {
    targetImage: {
      type: Object,
      default: null
    },
  },

  mounted() {
    if (this.targetImage) {
      this.request.numberMachine = this.targetImage.fixedRentalNumberMachine;
    }
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion

    //#region Close this pop-up
    closeThisPopup() {
      this.closePopup(POPUP_ID.FIXED_RENTAL_DEACTIVATE);
    },
    //#endregion

    deactivate() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          listMachineId: [this.targetImage.id],
          period: this.request.period,
          periodUnit: this.request.periodUnit,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        api.baseRequest(SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_DEACTIVATE, data)
          .then(() => {
            EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
            EventBus.$emit("processingEventRental", { event: "autoRefresh" });
            this.closeThisPopup();
            this.notificationSuccess('Success ... !', `Image <span style="color: #42A5F5;"> #${this.targetImage.id} (${this.targetImage.name})</span> has been successfully deactivated</span>`);
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
          })
          .catch(error => {
            this.processCatchApiRequest(error, "Boot failed ...")
          });
      }, this.smoothTimeOut);
    }
  },
}